import { render, staticRenderFns } from "./LayoutContentVerticalNavAdmin.vue?vue&type=template&id=9d041308&scoped=true"
import script from "./LayoutContentVerticalNavAdmin.vue?vue&type=script&lang=js"
export * from "./LayoutContentVerticalNavAdmin.vue?vue&type=script&lang=js"
import style0 from "./LayoutContentVerticalNavAdmin.vue?vue&type=style&index=0&id=9d041308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d041308",
  null
  
)

export default component.exports